jQuery(document).ready(function($) {
    $("#contact-form-wrapper input").attr("autocomplete", "off");
    let $ingredient_flag = 3;
    let $stage_flag = 3;

    $('.codedropz-upload-inner').prepend('<img id="cloud-icon" src="../wp-content/themes/soy/assets/cloud-icon.png" />');
    $('.codedropz-btn-wrap').after('<p id="upload-text">Extensions acceptées : .png, .jpg, .gif (maximum 1 Mo)</p>');


    //menu navigation
    $("#custom-search-icon").click(function() {
        $("#custom-search-form-wrapper").fadeToggle();
    });

    $('#searchform').attr('autocomplete', 'off');

    $("#mobile-toggle").click(function() {
        if ($('.nav-wrapper').hasClass('active')) {
            $('.nav-wrapper').css('width', '0px');
            $('.nav-wrapper').removeClass('active');
            $('html, body').css({
                'overflow-y': 'auto',
                height: 'auto'
            });

        } else {
            $('.nav-wrapper').css('width', '250px');
            $('.nav-wrapper').addClass('active');
            $('html, body').css({
                'overflow-y': 'hidden',
                height: '100%'
            });
        }
    });

    //faq slide questions/answers
    //question 1
    $("#arrow-1").click(function() {
        $("#arrow-2").slideToggle();
        $("#wrapper-a-1").slideToggle();
        $("#arrow-1").hide();
    });

    $("#arrow-2").click(function() {
        $("#arrow-1").slideToggle();
        $("#wrapper-a-1").slideToggle();
        $("#arrow-2").hide();
    });
    //question 2
    $("#arrow-3").click(function() {
        $("#arrow-4").slideToggle();
        $("#wrapper-a-2").slideToggle();
        $("#arrow-3").hide();
    });

    $("#arrow-4").click(function() {
        $("#arrow-3").slideToggle();
        $("#wrapper-a-2").slideToggle();
        $("#arrow-4").hide();
    });
    //question 3
    $("#arrow-5").click(function() {
        $("#arrow-6").slideToggle();
        $("#wrapper-a-3").slideToggle();
        $("#arrow-5").hide();
    });

    $("#arrow-6").click(function() {
        $("#arrow-5").slideToggle();
        $("#wrapper-a-3").slideToggle();
        $("#arrow-6").hide();
    });
    //question 4
    $("#arrow-7").click(function() {
        $("#arrow-8").slideToggle();
        $("#wrapper-a-4").slideToggle();
        $("#arrow-7").hide();
    });

    $("#arrow-8").click(function() {
        $("#arrow-7").slideToggle();
        $("#wrapper-a-4").slideToggle();
        $("#arrow-8").hide();
    });

    //question 5

    $("#arrow-9").click(function() {
        $("#arrow-10").slideToggle();
        $("#wrapper-a-5").slideToggle();
        $("#arrow-9").hide();
    });

    $("#arrow-10").click(function() {
        $("#arrow-9").slideToggle();
        $("#wrapper-a-5").slideToggle();
        $("#arrow-10").hide();
    });

    //question 6
    $("#arrow-11").click(function() {
        $("#arrow-12").slideToggle();
        $("#wrapper-a-6").slideToggle();
        $("#arrow-11").hide();
    });

    $("#arrow-12").click(function() {
        $("#arrow-11").slideToggle();
        $("#wrapper-a-6").slideToggle();
        $("#arrow-12").hide();
    });

    //question 7
    $("#arrow-13").click(function() {
        $("#arrow-14").slideToggle();
        $("#wrapper-a-7").slideToggle();
        $("#arrow-13").hide();
    });

    $("#arrow-14").click(function() {
        $("#arrow-13").slideToggle();
        $("#wrapper-a-7").slideToggle();
        $("#arrow-14").hide();
    });


    //partage recette form

    $("#add-icon-ingredient, #add-icon-stage").attr("src", "../wp-content/themes/soy/assets/card_slider_icon.png");

    $("div.ingredients-form div.ingredients-form-recette:last-child label").prepend("<span class='retirer'>Retirer cet ingrédient</span>");
    $("div.stage-recette div.etape-form:last-child label").prepend("<span class='retirer-2'>Retirer cette étape</span>");

    //ingredient
    $("#add-ingredient-text,#add-icon-ingredient").click(function() {
        $ingredient_flag = $ingredient_flag + 1;
        $('.retirer').fadeOut(300, function() {
            $(this).remove();
        });

        $("div.ingredients-form").append(
            $("<div class='col-12 ingredients-form-recette'>" +
                "<label>" +
                "<span class='retirer'>Retirer cet ingrédient</span>Ingrédient " + $ingredient_flag + ":<br>" +
                "<span class='wpcf7-form-control-wrap your-ingredient'>" +
                "<input type='text' name='your-ingredient-" + $ingredient_flag + "' value='' size='40' class='wpcf7-form-control wpcf7-text wpcf7-validates-as-required address-form'" +
                "aria-required='true' aria-invalid='false'></span><br></label></div>"
            ).hide().fadeIn(300)
        );

    });

    $("div.ingredients-form").on("click", ".retirer", function() {

        $ingredient_flag = $ingredient_flag - 1;
        $(this).parent().fadeOut(300, function() {
            $(this).parent().remove();
            $("div.ingredients-form div.ingredients-form-recette:last-child label").prepend("<span class='retirer'>Retirer cet ingrédient</span>");
        });
    });

    //stages
    $("#add-stage-text,#add-icon-stage").click(function() {
        $stage_flag = $stage_flag + 1;
        $('.retirer-2').fadeOut(300, function() {
            $(this).remove();
        });

        $("div.stage-recette").append(
            $("<div class='col-12 etape-form'>" +
                "<label><span class='retirer-2'>Retirer cette étape</span>Étape " + $stage_flag + " :<br>" +
                "<span class='wpcf7-form-control-wrap your-stage'>" +
                "<textarea name='your-stage-" + $stage_flag + "' cols='40' rows='10' class='wpcf7-form-control wpcf7-textarea message' aria-invalid='false' placeholder='Décrivez cette étape'></textarea></span></label>" +
                "</div>"
            ).hide().fadeIn(300)
        );

    });

    $("div.stage-recette").on("click", ".retirer-2", function() {

        $stage_flag = $stage_flag - 1;
        $(this).parent().fadeOut(300, function() {
            $(this).parent().remove();
            $("div.stage-recette div.etape-form:last-child label").prepend("<span class='retirer-2'>Retirer cette étape</span>");
        });


    });


    //Nos produits category
    $('.produit-list').isotope({
        itemSelector: '.produit-list-item',
    });


    //categories button actions

    $(".produit-button-wrap .parent-tax-wrap").on("click", function() {
        $('.child-tax').removeClass('active2');
        $('.sub-child-tax').removeClass('active4');
        var filterValue = $("span", this).attr('data-filter');
        let $id = $("span", this).attr('data-type');
        $('.produit-list').isotope({
            filter: filterValue,
            hiddenStyle: {
                opacity: 0
            },
            visibleStyle: {
                opacity: 1
            }

        });

        if ($(this).hasClass('active3')) {
            $('.produit-list').isotope({ filter: '*' });
            $('.recette-list').isotope({ filter: '*' });
            $(this).removeClass('active3');
            $(".child-tax-wrapper").css('display', 'none');
            $(".sub-child-tax-wrapper").css('display', 'none');
            $("#sub-cat-" + $id + "-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-11-img,#child-sub-cat-8-img,#child-sub-cat-9-img,#child-sub-cat-10-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-13-img,#child-sub-cat-15-img,#child-sub-cat-34-img,#child-sub-cat-41-img,#child-sub-cat-39-img, #child-sub-cat-33-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-17-img,#child-sub-cat-16-img").each(function() {
                $(this).css('display', 'none');
            });

            $("#child-sub-cat-22-img,#child-sub-cat-23-img").each(function() {
                $(this).css('display', 'none');
            });


        } else {
            $("#sub-cat-4-img, #sub-cat-5-img,#sub-cat-6-img, #sub-cat-7-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-13-img,#child-sub-cat-15-img,#child-sub-cat-34-img,#child-sub-cat-41-img,#child-sub-cat-39-img, #child-sub-cat-33-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-11-img,#child-sub-cat-8-img,#child-sub-cat-9-img,#child-sub-cat-10-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-17-img,#child-sub-cat-16-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-22-img,#child-sub-cat-23-img").each(function() {
                $(this).css('display', 'none');
            });

            $(".child-tax-wrapper").css('display', 'none');
            $(".sub-child-tax-wrapper").css('display', 'none');
            $(this).addClass('active3');
            $('.parent-tax-wrap').not(this).removeClass('active3');
            $("#sub-cat-" + $id).css('display', 'flex');
            $("#sub-cat-" + $id + "-img").css('display', 'inline-block')

        }
    });

    $('.child-tax').click(function() {
        $('.sub-child-tax').removeClass('active4');
        var filterValue = $(this).attr('data-filter');
        var parentfilterValue = $(this).attr('data-parent');
        let $child_id = $(this).attr('data-type');
        console.log(filterValue);

        $('.produit-list').isotope({
            filter: filterValue,
            hiddenStyle: {
                opacity: 0
            },
            visibleStyle: {
                opacity: 1
            }

        });

        if ($(this).hasClass('active2')) {
            $('.produit-list').isotope({
                filter: parentfilterValue,
                hiddenStyle: {
                    opacity: 0
                },
                visibleStyle: {
                    opacity: 1
                }

            });
            $(this).removeClass('active2');
            $(".sub-child-tax-wrapper").css('display', 'none');
            $("#child-sub-cat-" + $child_id + "-img").each(function() {
                $(this).css('display', 'none');
            });

        } else {
            $("#child-sub-cat-13-img,#child-sub-cat-15-img,#child-sub-cat-34-img,#child-sub-cat-41-img,#child-sub-cat-39-img, #child-sub-cat-33-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-11-img,#child-sub-cat-8-img,#child-sub-cat-9-img,#child-sub-cat-10-img").each(function() {
                $(this).css('display', 'none');
            });

            $("#child-sub-cat-17-img,#child-sub-cat-16-img").each(function() {
                $(this).css('display', 'none');
            });
            $("#child-sub-cat-22-img,#child-sub-cat-23-img").each(function() {
                $(this).css('display', 'none');
            });

            $(".sub-child-tax-wrapper").css('display', 'none');
            $(this).addClass('active2');
            $('.child-tax').not(this).removeClass('active2');
            $("#sub-child-cat-" + $child_id).css('display', 'flex');
            $("#child-sub-cat-" + $child_id + "-img").css('display', 'inline-block')

        }
    });

    $('.sub-child-tax').click(function() {
        var filterValue = $(this).attr('data-filter');
        var parentfilterValue = $(this).attr('data-parent');


        $('.produit-list').isotope({
            filter: filterValue,
            hiddenStyle: {
                opacity: 0
            },
            visibleStyle: {
                opacity: 1
            }

        });

        if ($(this).hasClass('active4')) {
            $('.produit-list').isotope({
                filter: parentfilterValue,
                hiddenStyle: {
                    opacity: 0
                },
                visibleStyle: {
                    opacity: 1
                }

            });
            $(this).removeClass('active4');

        } else {
            $('.sub-child-tax').not(this).removeClass('active4');
            $(this).addClass('active4');


        }
    });

    //end categories button

    $("#analyse-tab").click(function() {
        $(this).addClass('active');
        $("#ingredient-tab").removeClass('active');


    });

    $("#ingredient-tab").click(function() {

        $(this).addClass('active');
        $("#analyse-tab").removeClass('active')


    });

    //search slide result per category
    //question 1
    $("#search-arrow-1").click(function() {
        $("#search-arrow-2").slideToggle();
        $("#search-product-wrap").slideToggle(function() {
            $(this).css('display', 'flex');
        });
        $("#search-arrow-1").hide();
    });

    $("#search-arrow-2").click(function() {
        $("#search-arrow-1").slideToggle();
        $("#search-product-wrap").slideToggle();
        $("#search-arrow-2").hide();
    });

    $("#search-arrow-3").click(function() {
        $("#search-arrow-4").slideToggle();
        $("#search-recette-wrap").slideToggle(function() {
            $(this).css('display', 'flex');
        });
        $("#search-arrow-3").hide();
    });

    $("#search-arrow-4").click(function() {
        $("#search-arrow-3").slideToggle();
        $("#search-recette-wrap").slideToggle();
        $("#search-arrow-4").hide();
    });

    $("#search-arrow-5").click(function() {
        $("#search-arrow-6").slideToggle();
        $("#search-others-wrap").slideToggle(function() {
            $(this).css('display', 'flex');
        });
        $("#search-arrow-5").hide();
    });

    $("#search-arrow-6").click(function() {
        $("#search-arrow-5").slideToggle();
        $("#search-others-wrap").slideToggle();
        $("#search-arrow-6").hide();
    });

    /*$('.slick-carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: "<a class='carousel-control-prev w-auto'><img src='/wp-content/themes/soy/assets/prev.png'></a>",
        nextArrow: "<a class='carousel-control-next w-auto'><img src='/wp-content/themes/soy/assets/next.png'></a>",
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '40px',
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    adaptiveHeight: true,
                    centerPadding: '40px',
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.slick-carousel-2').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: "<a class='carousel-control-prev w-auto'><img src='/wp-content/themes/soy/assets/prev.png'></a>",
        nextArrow: "<a class='carousel-control-next w-auto'><img src='/wp-content/themes/soy/assets/next.png'></a>",
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '10px',
                swipeToSlide: true

            }
        },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    centerMode: true,
                    adaptiveHeight: true,
                    centerPadding: '10px',
                    swipeToSlide: true

                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    adaptiveHeight: true,
                    centerPadding: '10px',
                    swipeToSlide: true

                }
            }

        ]
    });

    $('.slick-carousel-3').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: "<a class='carousel-control-prev w-auto'><img src='/wp-content/themes/soy/assets/prev.png'></a>",
        nextArrow: "<a class='carousel-control-next w-auto'><img src='/wp-content/themes/soy/assets/next.png'></a>",
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: false,
                centerMode: true,
                adaptiveHeight: true,
                centerPadding: '0px',
                swipeToSlide: true

            }
        },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    centerMode: true,
                    adaptiveHeight: true,
                    centerPadding: '10px',
                    swipeToSlide: true

                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    centerMode: true,
                    adaptiveHeight: true,
                    centerPadding: '10px',
                    swipeToSlide: true

                }
            }

        ]
    });*/

    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            /* Toggle between adding and removing the "active" class,
            to highlight the button that controls the panel */
            this.classList.toggle("active");

            /* Toggle between hiding and showing the active panel */
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }



    var windowWidth = $(window).innerWidth();

    //console.log("tailles",elementorFrontend.config.responsive.breakpoints);
    if (elementorFrontend.config.responsive.breakpoints) {

        var windowMinWidth = elementorFrontend.config.responsive.breakpoints.tablet.value;
    } else {
        var windowMinWidth = 768;
    }
    var windowResponsiveMobile = windowWidth < windowMinWidth;
    function swapChildren(obj1, obj2) {
        var temp = obj2.children().detach();
        obj2.empty().append(obj1.children().detach());
        obj1.append(temp);
    }
    function toggleMobileStyles() {
        console.log("toggleMobileStyles");
        console.log("breakpoints", elementorFrontend.config.responsive.breakpoints);
        if (windowResponsiveMobile) {
            console.log('on passe le desktop en mobile');
            $("[id^='_desktop_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        } else {
            console.log('on passe mobile en desktop');
            $("[id^='_mobile_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        }
    }
    $(window).on('resize', function () {
        var _cw = windowWidth;
        var _mw = windowMinWidth;
        var _w = $(window).innerWidth();
        var _toggle = _cw >= _mw && _w < _mw || _cw < _mw && _w >= _mw;
        windowWidth = _w;
        windowResponsiveMobile = windowWidth < windowMinWidth;
        //console.log('_toggle', _toggle)
        if (_toggle) {
            toggleMobileStyles();
        }
    });
    $(document).ready(function () {
        if (windowResponsiveMobile) {
            toggleMobileStyles();
        }
    });

    // Add your JS customizations here









});